import { Alert, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import Plot, { Figure } from "react-plotly.js";

import { PartialBy } from "types/util";
import { ExtendeChartData } from "types/plotly";

interface Props {
  // TODO: FIX ME TEMP
  chartData?: PartialBy<Figure, "frames"> & ExtendeChartData;
  graphWidth?: string;
  graphHeight?: string;
  graphMaxWidth?: string;
  graphMaxHeight?: string;
  graphMargin?: string;
}

export function Graph(props: Props) {
  const {
    chartData,
    graphWidth,
    graphHeight,
    graphMaxHeight,
    graphMaxWidth,
    graphMargin,
  } = props;
  const { t } = useTranslation();
  return (
    <>
      {!chartData && (
        <StyledAlert severity="info">
          {t("label.thisIndicatorHasNoData")}
        </StyledAlert>
      )}
      {chartData && (
        <Plot
          useResizeHandler={true}
          style={{
            width: graphWidth ? graphWidth : "100%",
            height: graphHeight ? graphHeight : "100%",
            maxWidth: graphMaxWidth ? graphMaxWidth : "unset",
            maxHeight: graphMaxHeight ? graphMaxHeight : "unset",
            marginLeft: graphMargin ? graphMargin : "unset",
          }}
          data={chartData.data}
          layout={{
            ...chartData.layout,
            yaxis: { ...chartData.layout.yaxis, fixedrange: true },
            xaxis: {
              ...chartData.layout.xaxis,
              tickformat: "",
              fixedrange: true,
            },
          }}
          config={{
            autosizable: true,
            displayModeBar: false,
            staticPlot: false,
            doubleClick: false,
            scrollZoom: false,
            showTips: false,
            showAxisDragHandles: false,
            responsive: true,
          }}
        />
      )}
    </>
  );
}

const StyledAlert = styled(Alert)`
  align-items: center;
  padding: 0;
  background-color: transparent;
`;
